import { formatRoundedNumber } from '@/lib/formatUtils';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

interface BottomBarProps {
  phi?: number;
  thue?: number;
  tong_thanh_toan?: number;
}

function BottomBar({ phi = 0, thue = 0, tong_thanh_toan = 0 }: BottomBarProps) {
  return (
    <div className='w-full border-t bg-white px-4 py-2'>
      <div className='flex'>
        <div className='flex flex-col'>
          {/* Column 1 */}
          <div className='flex items-center'>
            <Label className='w-32 font-medium'>Chi phí</Label>
            <div className='w-[100px] pb-1'>
              <FormField name='t_cp_nt' value={formatRoundedNumber(phi)} />
              <FormField name='t_cp' value={formatRoundedNumber(phi)} className='hidden' />
            </div>
          </div>

          <div className='flex items-center'>
            <Label className='w-32 font-medium'>Tổng thuế</Label>
            <div className='w-[100px] pb-1'>
              <FormField name='t_thue_nt' value={formatRoundedNumber(thue)} />
              <FormField name='t_thue' value={formatRoundedNumber(thue)} className='hidden' />
            </div>
          </div>

          <div className='flex items-center'>
            <Label className='w-32 font-medium'>Tổng thanh toán</Label>
            <div className='w-[100px] pb-1'>
              <FormField name='t_tt_nt' value={formatRoundedNumber(tong_thanh_toan)} />
              <FormField name='t_tt' value={formatRoundedNumber(tong_thanh_toan)} className='hidden' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BottomBar;
